<template>
  <div class="item-card">
    <div class="card-title">创意基础设置</div>
    <div class="card-content">
      <ul class="modal-form">
        <el-form :model="formData" :rules="rules" ref="creativeBasesetRef">
          <li class="form-item">
            <span class="form-label require" style="padding-top: 8px"
              >创意名称：</span
            >
            <div class="form-value">
              <select-input
                placeholder="(必填)请输入创意名称"
                ref="createNameRef"
                :dataList="selectInputList"
                v-model="formData.name_rule"
              ></select-input>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">广告位置：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.scene_id">
                <el-radio :label="1" v-if="delivery_range === 'default'"
                  >优选广告位</el-radio
                >
                <el-radio label="scene" v-if="delivery_range === 'default'"
                  >按场景选择广告位</el-radio
                >
                <el-radio :label="5" v-else>快手联盟广告位</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item" v-show="formData.scene_id === 'scene'">
            <span class="form-label"></span>
            <div class="form-value">
              <div class="raido-wrap">
                <el-radio-group v-model="formData.senceType">
                  <el-radio :label="6">
                    <div class="radio-item-wrap">
                      <div class="radio-title">上下滑大屏广告</div>
                      <div class="radio-det">
                        全面沉浸式广告体验，广告展示效率高、转化高
                      </div>
                    </div>
                  </el-radio>
                  <el-radio :label="10">
                    <div class="radio-item-wrap">
                      <div class="radio-title">快手广告联盟</div>
                      <div class="radio-det">
                        在快手广告联盟流量展示的广告，可获取海量新增流量
                      </div>
                    </div>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">创意制作方式：</span>
            <div class="form-value">
              <el-radio-group>
                <el-radio :checked="true">程序化创意</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">智能抽帧：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.smart_cover">
                <el-radio :label="false">关闭</el-radio>
                <el-radio :label="true">开启</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li
            class="form-item"
            v-if="
              formData.scene_id === 1 ||
              (formData.senceType === 6 && formData.scene_id !== 5)
            "
          >
            <span class="form-label">封面贴纸：</span>
            <div class="form-value">
              <div class="tz-wrap">
                <el-form-item prop="overlay_type">
                  <el-checkbox-group v-model="formData.overlay_type">
                    <el-checkbox
                      v-for="item of tzList"
                      :key="item.overlay_type"
                      :label="item.overlay_type"
                    >
                      <div class="img-wrap">
                        <img :src="item.overlay_preview_url" />
                      </div>
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </div>
          </li>
          <li
            class="form-item"
            v-if="
              formData.scene_id === 1 ||
              (formData.senceType === 6 && formData.scene_id !== 5)
            "
          >
            <span class="form-label" style="padding-top: 8px"
              >封面广告语({{ formData.cover_slogans.length }}/6)：</span
            >
            <div class="form-value">
              <el-form-item prop="cover_slogans">
                <div
                  style="margin-bottom: 0px"
                  :key="item.key"
                  v-for="item of formData.cover_slogans"
                >
                  <el-input
                    type="text"
                    placeholder="(必填)14个字符以内"
                    maxlength="14"
                    show-word-limit
                    style="width: 280px"
                    v-model="item.text"
                  ></el-input>
                  <i
                    class="el-icon-plus action-icon"
                    @click="addAdslogan()"
                  ></i>
                  <i
                    v-if="formData.cover_slogans.length > 1"
                    class="el-icon-minus action-icon"
                    @click="delAdslogan(item.key)"
                  ></i>
                </div>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label require" style="padding-top: 8px"
              >行动号召：</span
            >
            <div class="form-value">
              <el-form-item prop="action_bar_text">
                <el-select
                  v-model="formData.action_bar_text"
                  placeholder="请选择行动号召"
                >
                  <el-option
                    v-for="item of xdhzList"
                    :label="item"
                    :value="item"
                    :key="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label">素材挖掘：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.asset_mining">
                <el-radio :label="false">关闭</el-radio>
                <el-radio :label="true">开启</el-radio>
              </el-radio-group>
            </div>
          </li>
          <li class="form-item">
            <span class="form-label" style="padding-top: 6px"
              >第三方检测链接：</span
            >
            <div class="form-value">
              <el-input
                placeholder="第三方检测链接"
                style="width: 280px"
                v-model="formData.clickUrl"
                :disabled="disableClickUrl"
                :title="formData.clickUrl"
              ></el-input>
            </div>
          </li>
        </el-form>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SelectInput from "../common/selectInput.vue";
import { creativeWord, actionBar } from "@/api/promotion-kuaishou.js";
import nameTransforUtil from "../common/nameTransforUtil.js";
export default {
  components: {
    SelectInput,
  },
  data() {
    return {
      formData: {
        name_rule: "",
        scene_id: 1,
        senceType: 6,
        // cz: "1",
        overlay_type: [],
        cover_slogans: [
          {
            key: Math.random(),
            text: "",
          },
        ],
        action_bar_text: null,
        clickUrl: "",
        smart_cover: false, //智能抽帧
        asset_mining: false, //素材挖掘
      },
      showClickUrl: "",
      disableClickUrl: false,
      tzList: [],
      xdhzList: [],
      rules: {
        action_bar_text: [
          {
            required: true,
            message: "请选择行动号召",
            trigger: ["blur", "change"],
          },
        ],
        overlay_type: [
          {
            validator: (rule, value, callback) => {
              let hasText = this.formData.cover_slogans.find(
                (item) => item.text
              );
              if (hasText) {
                if (value.length > 0) {
                  callback();
                } else {
                  callback(new Error("请选择封面贴纸"));
                }
              } else {
                callback();
              }
            },
            trigger: ["change"],
          },
        ],
        cover_slogans: [
          {
            validator: (rule, value, callback) => {
              if (this.formData.overlay_type.length > 0) {
                let pass = value.find((item) => item.text);
                if (pass) {
                  callback();
                } else {
                  callback(new Error("请填写封面广告语"));
                }
              } else {
                callback();
              }
            },
            trigger: ["change"],
          },
        ],
      },
      selectInputList: [
        "营销目标",
        "应用名称",
        "应用标记",
        "创建日期",
        "首个视频名称",
        "首个图片名称",
        "转化跟踪名称",
        "创意制作类型",
      ],
    };
  },
  methods: {
    initOptions() {
      creativeWord({
        advertiserId: this.adCount.advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.tzList = res.stickers.map((item) => item.sticker_styles[1]);
        }
      });
      actionBar({
        advertiserId: this.adCount.advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.xdhzList = res.actions;
        }
      });
      //查询下拉
      //加载store数据
      this.fillStoreData();
    },
    addAdslogan() {
      if (this.formData.cover_slogans.length > 5) {
        return;
      } else {
        this.formData.cover_slogans.push({
          key: Math.random(),
          text: "",
        });
      }
    },
    delAdslogan(key) {
      let dataList = this.formData.cover_slogans;
      let delIndex = dataList.findIndex((item) => item.key === key);
      dataList.splice(delIndex, 1);
    },
    saveInStore() {
      //广告位置
      let scene_id = null;
      if (this.formData.scene_id === "scene") {
        scene_id = this.formData.senceType;
      } else {
        scene_id = this.formData.scene_id;
      }
      this.$store.commit("set_scene_id_k", [scene_id]);

      // 名称
      this.$store.commit(
        "set_create_name_rule_k",
        nameTransforUtil.showDataToApi(this.formData.name_rule)
      );

      //贴纸和广告语
      let slogans = this.formData.cover_slogans
        .map((item) => item.text)
        .filter((item) => item);
      this.$store.commit("set_overlay_group_k", {
        overlay_type: this.formData.overlay_type,
        cover_slogans: slogans,
      });

      //智能抽帧和素材挖掘
      this.$store.commit("set_cover_mining_k", {
        smart_cover: this.formData.smart_cover,
        asset_mining: this.formData.asset_mining,
      });

      //行动号召
      this.$store.commit(
        "set_action_bar_text_k",
        this.formData.action_bar_text
      );
      //监测链接
      this.$store.commit("setclickUrl_k", this.formData.clickUrl);
    },
    fillStoreData() {
      //广告位置
      let curId = this.scene_id[0];
      if (curId === 6 || curId === 10) {
        this.formData.scene_id = "scene";
        this.formData.senceType = curId;
      } else {
        this.formData.scene_id = curId;
      }
      //名称
      this.formData.name_rule = nameTransforUtil.apiDatatoShow(this.name_rule);
      //贴纸和广告语
      if (this.overlay_group) {
        let cover_slogansArr = this.overlay_group.cover_slogans;
        this.formData.cover_slogans =
          cover_slogansArr.length === 0
            ? [
                {
                  key: Math.random(),
                  text: "",
                },
              ]
            : cover_slogansArr.map((item) => {
                return {
                  key: Math.random(),
                  text: item,
                };
              });
        this.formData.overlay_type = this.overlay_group.overlay_type;
      }
      //智能抽帧和素材挖掘
      this.formData.smart_cover = this.draft_ad.smart_cover || false;
      this.formData.asset_mining = this.draft_ad.asset_mining || false;
      //行动号召
      this.formData.action_bar_text = this.action_bar_text;
      //监测链接
      this.formData.clickUrl = this.clickUrl;
    },
    checkData() {
      return Promise.all([
        this.$refs.createNameRef.checkData(),
        new Promise((resolve, reject) => {
          this.$refs.creativeBasesetRef.validate((valid) => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        }),
      ]);
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionKuaishou.adCount,
      clickUrl: (state) => state.PromotionKuaishou.draft_ad.clickUrl,
      delivery_range: (state) =>
        state.PromotionKuaishou.draft_adset.delivery_placement.delivery_range,
      scene_id: (state) =>
        state.PromotionKuaishou.draft_adset.delivery_placement.scene_id,
      name_rule: (state) => state.PromotionKuaishou.draft_ad.name_rule,
      overlay_group: (state) => state.PromotionKuaishou.draft_ad.overlay_group,
      action_bar_text: (state) =>
        state.PromotionKuaishou.draft_ad.action_bar_text,
      promote_object: (state) =>
        state.PromotionKuaishou.draft_adset.promote_object,
      draft_ad: (state) => state.PromotionKuaishou.draft_ad,
    }),
  },
  watch: {
    //投放范围联动广告位置
    delivery_range(value) {
      if (value === "default") {
        this.formData.scene_id = 1;
      } else if (value === "unit") {
        this.formData.scene_id = 5;
      }
    },
    promote_object: {
      handler(value) {
        if (value) {
          if (value.convert_id) {
            //应用api
            this.disableClickUrl = true;
            this.formData.clickUrl = this.clickUrl;
          } else {
            this.disableClickUrl = false;
          }
        }
      },
      deep: true,
    },
    clickUrl(value) {
      this.formData.clickUrl = value;
    },
  },
};
</script>

<style  lang="less" scoped>
.item-card {
  background-color: #fff;
  padding: 24px;
  margin-bottom: 6px;
  .card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
  }
  .card-content {
    margin-top: 20px;
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 20px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 130px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          // padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(0, 0, 0, 0.65);
          }

          .raido-wrap {
            border: 1px solid #eee;
            padding: 10px 0;
            box-sizing: border-box;
            /deep/ .el-radio-group {
              width: 100%;
            }
            /deep/ .el-radio {
              padding: 10px;
              display: flex;
              flex-direction: row-reverse;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              box-sizing: border-box;
              &:hover {
                background-color: #f5f6f7;
              }
            }
            .radio-item-wrap {
              .radio-title {
                font-size: 12px;
                color: #000;
                font-weight: bold;
                margin-bottom: 4px;
              }
              .radio-det {
                font-size: 12px;
                color: #818181;
              }
            }
          }
          .tz-wrap {
            /deep/ .el-checkbox {
              position: relative;
              margin-right: 14px;
              margin-bottom: 12px;
              .el-checkbox__input {
                position: absolute;
                top: 6px;
                right: 6px;
              }
              .el-checkbox__label {
                padding: 0px;
              }
            }
            .img-wrap {
              width: 98px;
              height: 98px;
              border: 1px solid #eee;
              border-radius: 4px;
              object-fit: contain;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .action-icon {
            margin-left: 6px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>